import React from 'react';

import { Typography } from '@material-ui/core';
import {
  PersonOutlined as PersonOutlinedIcon,
  LocalTaxiOutlined as LocalTaxiOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';
import HelpTooltip from '../SteppedForm/HelpTooltip';

const StepVehicleOnboarding = (props) => {
  return (
    <Step id="vehicleOnboarding" title="Application Type" nonext>
      <Typography variant="body1">
        Do you want to onboard additional Vehicles to this Operator account?
      </Typography>
      <Typography variant="body1" class="formQuestion">
        As a current Operator with one of our networks, you may choose to onboard additonal Vehicles
        through this process.
      </Typography>
      <HelpTooltip title="By clicking this button, you are indicating that you would like to continue through the normal Operator onboarding process, with the intent of creating a new Operator account.">
        <ButtonField
          id="onboardingFor"
          value={'operator'}
          label="Set up a new Operator Account"
          className="TopIconButton"
          startIcon={<PersonOutlinedIcon />}
        />
      </HelpTooltip>

      <HelpTooltip title="By clicking this button, you are indicating that you would like to add additional vehicles to your existing Operator account.">
        <ButtonField
          id="onboardingFor"
          value={'vehicle'}
          label="Onboard Vehicle Only"
          className="TopIconButton"
          startIcon={<LocalTaxiOutlinedIcon />}
        />
      </HelpTooltip>
    </Step>
  );
};

export default StepVehicleOnboarding;
